<template>
	<div>
		<div
			class="modal fade campaign-tags"
			id="taggable"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Tags</h5>
					</div>
					<div class="modal-body" style ="padding-top :25px" v-if="isLoading">
						<div
						class="spinner-border"
						style="margin:40px auto;display:block;"
						></div>
					</div>
					<div class="modal-body" style="margin-top:25px" v-else>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Brand Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="brandTags"
								    :options="tagsList.filter(tag => tag.type === 'brand')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addBrandTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Brand Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>

						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Category Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="categoryTags"
								    :options="tagsList.filter(tag => tag.type === 'product_category')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addCategoryTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Category Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>

						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Sub-Category Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="subcategoryTags"
								    :options="tagsList.filter(tag => tag.type === 'subcategory')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addSubcategoryTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Sub-Category Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Style Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="styleTags"
								    :options="tagsList.filter(tag => tag.type === 'style')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addStyleTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select Style Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Tactic 1 Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="tactic1Tags"
									:options="['Awareness', 'Consideration', 'Purchase', 'Loyalty', 'Excluded'].map(title => ({title, type: 'tactic_1' }))"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addTactic1Tag($event)"
								    open-direction="bottom"
								    :taggable="false"
								    placeholder="Select Tactic 1 Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">Tactic 2 Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="tactic2Tags"
									:options="['Outside Aisle', 'Contextual', 'Added Value', 'Added Value - Targeting', 'Inside Aisle', 
									'Conquesting', 'Retargeting', 'Cross-sell', 'Up-sell', 'Retention', 'FSA/HSA Eligible', 'Excluded'].map(title => ({title, type: 'tactic_2' }))"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addTactic2Tag($event)"
								    open-direction="bottom"
								    :taggable="false"
								    placeholder="Select Tactic 2 Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-md-3">
								<label for="name">GL Tags</label>
							</div>
							<div class = "col-md-6">
								<multiselect
								    v-model="glTags"
								    :options="tagsList.filter(tag => tag.type === 'gl')"
								    :searchable="true"
								    ref="multiselect"
								    label="title"
								    track-by="title"
								    @tag="addGLTag($event)"
								    open-direction="bottom"
								    :taggable="true"
								    placeholder="Select GL Tag"
								    class="form-control multi-dropdown col-md-12"
								    :multiple="false"
								    id="campaignTags"
									:closeOnSelect="true"
										>
								</multiselect>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" @click="hideModal()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button
								:disabled="[].concat(this.brandTags, this.categoryTags, this.subcategoryTags, this.styleTags, this.tactic1Tags, this.tactic2Tags, this.glTags).length === 0"
								type="button"
								class="btn btn-primary"
								@click = "saveTagsForCampaign()"
								>Save changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Multiselect from "vue-multiselect";

	export default {
		name: "TagDsp",
		components: {
			Multiselect
		},
		data() {
			return {
				// tags:[],
				brandTags: [],
				categoryTags: [],
				subcategoryTags:[],
				styleTags: [],
				tactic1Tags: [],
				tactic2Tags: [],
				glTags: [],
				tagsList:[],
				selectedCampaigns:[],
				dspList:[],
				isLoading:false
			};
		},
		mounted() {
			this.getTagsList()
		},
		methods: {
			addBrandTag(name){
				var pay = { title: name, type: 'brand' }
				this.brandTags = pay
			},
			addCategoryTag(name){
				var pay = { title: name, type: 'product_category'  }
				this.categoryTags = pay
			},
			addSubcategoryTag(name){
				var pay = { title: name, type: 'subcategory'  }
				this.subcategoryTags = pay
			},
			addStyleTag(name){
				var pay = { title: name, type: 'style'  }
				this.styleTags = pay
			},
			addTactic1Tag(name){
				var pay = { title: name, type: 'tactic_1'  }
				this.tactic1Tags = pay
			},
			addTactic2Tag(name){
				var pay = { title: name, type: 'actic_2'  }
				this.tactic2Tags = pay
			},
			addGLTag(name){
				var pay = { title: name, type: 'gl'  }
				this.glTags = pay
			},
			getTagsList(){
				const vm = this;
				const advertiser_id = this.$store.state.dspAdvertiser ? this.$store.state.dspAdvertiser.value : undefined
				console.log('advertiser_id :', advertiser_id )
				this.$store.dispatch("getDspTagOptions", {advertiser_id: advertiser_id}).then((res) => {
					vm.tagsList = res
					this.$store.state.listOfTags = vm.tagsList
				})
			},
			hideModal(){
				// this.tags = [];
				this.tagsList = []
				this.selectedDsp = [];
				this.dspList = [];
				this.brandTags = [];
				this.categoryTags = [];
				this.subcategoryTags = [];
				this.styleTags = [];
				this.tactic1Tags = [];
				this.tactic2Tags = [];
				this.glTags = [];
				this.$emit('closeModal')
			},
			saveTagsForCampaign(){
				let payload = {
					order_ids: this.$store.state.selectedBulkDsp,
				    brand_tag: this.brandTags.title, 
					cat_tag: this.categoryTags.title, 
					subcategory_tag: this.subcategoryTags.title, 
					style_tag: this.styleTags.title, 
					t1_tag: this.tactic1Tags.title,
					t2_tag: this.tactic2Tags.title, 
					gl_tag: this.glTags.title
				}
				this.isLoading = true;
				let vm = this;
				console.log(payload)
				this.$store.dispatch("saveOrderTags", payload).then((res) => {
					vm.isLoading = false
					vm.hideModal()
					location.reload();
				})
			}
		}
	};
</script>


<style lang="scss">
.campaign-tags {
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
}
.campaign-tags {
	.multiselect__option span{
		text-transform: none !important;
	}
}
.campaign-tags {
	.multiselect__tag{
		text-transform: none !important;
	}
}

</style>
